import { push } from 'react-router-redux';
import Cookies from 'js-cookie';

import forceLogoutHandler from '../users/a.users.forceLogoutHandler';

import {
  
} from '../actions.export'

////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////
// Create an instruction
////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////

export const requestCreateNewInstruction = packet => {
  return {
    type: 'REQUEST_CREATE_NEW_INSTRUCTION',
    data: {
      lastSubmit: packet
    }
  }
}

export const receiveCreateNewInstructionSuccess = data => ({
  type: 'RECEIVE_CREATE_NEW_INSTRUCTION_SUCCESS',
  data
})

export const receiveCreateNewInstructionFail = data => ({
  type: 'RECEIVE_CREATE_NEW_INSTRUCTION_FAIL',
  data
})

export const tryToCreateNewInstruction = packet => (dispatch, getState) => {

  dispatch(requestCreateNewInstruction(packet));

  let headers = {
    "Content-Type": "application/json"
  }
  


  let fs = localStorage.getItem(process.env.REACT_APP_COOKIE_FEATURE_SWITCH);
  if(fs){
    headers["X-NFS"] = fs;
  }


  headers["X-CSRF-TOKEN"] = getState().userReducer.csrf_token;

  return fetch('/api/instructions/organization/' + packet.scope, {
      method: 'post',
      body: JSON.stringify(packet),
      headers: headers
    })
    .then((response) => {
      let json = response.json();
      if (response.status >= 200 && response.status < 300) return json;
      return json.then(Promise.reject.bind(Promise));
    })
    .then(function(json){
      dispatch(receiveCreateNewInstructionSuccess(json));
    })
    .catch(e => {
      dispatch(forceLogoutHandler(e));
      dispatch(receiveCreateNewInstructionFail({errors:e, lastSubmit: packet}));
    })
}
